<script setup lang="ts"></script>

<template>
  <UApp :toaster="{ position: 'bottom-left' }">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
